import { render, staticRenderFns } from "./EditReglements.vue?vue&type=template&id=15400973&"
import script from "./EditReglements.vue?vue&type=script&lang=ts&"
export * from "./EditReglements.vue?vue&type=script&lang=ts&"
import style0 from "./EditReglements.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports